import React from 'react';
import Icon from '@pushpay/icon';

const FinanceIcon = props => {
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.478 2 2 6.478 2 12c0 5.523 4.478 10 10 10 5.523 0 10-4.477 10-10 0-5.522-4.477-10-10-10zm1.22 15.49a.209.209 0 00-.178.206v.637a1.042 1.042 0 01-2.084 0v-.587a.207.207 0 00-.206-.208h-.958a1.042 1.042 0 010-2.084h2.99a.932.932 0 00.346-1.796l-3.033-1.215a3.004 3.004 0 01.683-5.766.208.208 0 00.178-.206v-.638a1.042 1.042 0 012.084 0v.589c0 .115.093.208.208.208h.956a1.042 1.042 0 010 2.083h-2.99a.93.93 0 00-.346 1.796l3.033 1.214a3.004 3.004 0 01-.683 5.766z",
    fill: "currentColor"
  }));
};

export default FinanceIcon;